import Intercom from "@intercom/messenger-js-sdk"
import { UserProfile } from "types/auth"

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || ""

export const bootIntercom = (user: UserProfile): void => {
  if (!INTERCOM_APP_ID) return

  Intercom({
    app_id: INTERCOM_APP_ID,
    user_id: user.id?.toString(),
    name: `${user.first_name || ""} ${user.last_name || ""}`.trim(),
    email: user.email,
    custom_launcher_selector: "#intercom-launcher",
    hide_default_launcher: false
  })
}

export const updateIntercom = (user: UserProfile): void => {
  if (!INTERCOM_APP_ID || typeof window === "undefined" || !window.Intercom) return

  window.Intercom("update", {
    user_id: user.id?.toString(),
    name: `${user.first_name || ""} ${user.last_name || ""}`.trim(),
    email: user.email
  })
}

export const shutdownIntercom = (): void => {
  if (typeof window === "undefined" || !window.Intercom) return
  window.Intercom("shutdown")
}

export const showIntercom = (): void => {
  if (typeof window === "undefined" || !window.Intercom) return
  window.Intercom("show")
}

export const hideIntercom = (): void => {
  if (typeof window === "undefined" || !window.Intercom) return
  window.Intercom("hide")
}
